//Notification Styles - styles.less
export enum NotificationStylesClass {
  SUCCESS = 'nz-notification-success',
  INFO = 'nz-notification-info',
  WARNING = 'nz-notification-warning',
  ERROR = 'nz-notification-error',
  HIDE_CLOSE_BUTTON = 'nz-notification-without-close'
}
